import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../../modules/translation/TranslationContext';

export interface LoginFormValues {
  email: string;
  password: string;
}

interface UseLoginFormParams {
  onSubmit: (values: LoginFormValues) => Promise<void>;
  defaultEmail?: string;
}

const useLoginForm = ({ onSubmit, defaultEmail = '' }: UseLoginFormParams) => {
  const { translate } = useTranslation();

  const schema = Yup.object().shape({
    email: Yup.string()
      .trim()
      .required(translate(LangEnum.GLOBAL_REQUIRED))
      .email(translate(LangEnum.GLOBAL_INVALID_EMAIL)),
    password: Yup.string().trim().required(translate(LangEnum.GLOBAL_REQUIRED)),
  });

  const formMethods = useForm<LoginFormValues>({
    resolver: yupResolver(schema) as unknown as Resolver<LoginFormValues>,
    defaultValues: { email: defaultEmail, password: '' },
    mode: 'onBlur',
  });

  const handleSubmit = formMethods.handleSubmit(async (data) => {
    await onSubmit({ email: data.email, password: data.password });
  });

  return { formMethods, handleSubmit };
};

export default useLoginForm;
